import React from 'react';
import { imagesPack } from '../assets/imagesPack';
import { ASSET_TYPE } from '../react-three-components/sceneAsset';
import { STUDIO_ID_SUFFIX } from 'util/constants';
import styles from '../add-to-scene.module.css';

export default function ImageContent({ onAddToScene }) {
  const handleImageClick = (image) => {
    onAddToScene({
      type: ASSET_TYPE.PRIMITIVE_TEXTURE.IMAGE_PLANE,
      url: image.url,
      name: image.name,
      ref: React.createRef(),
    });
  };

  return (
    <div className={styles.gridContainer}>
      {imagesPack.map((image, index) => (
        <div
          key={`${index}-${image.name}`}
          className={styles.libraryItem}
          onClick={() => handleImageClick(image)}
        >
          <div className={styles.libraryThumbnail}>
            <img
              src={image.thumbnail}
              alt={image.name}
              className={styles.libraryThumbnailImg}
            />
          </div>

          <div className={styles.libraryItemName}>
            {image.name.replace(STUDIO_ID_SUFFIX, '')}
          </div>

          <button
            className={styles.addToSceneButton}
            onClick={(e) => {
              e.stopPropagation();
              handleImageClick(image);
            }}
          >
            Add to scene
          </button>
        </div>
      ))}
    </div>
  );
}
